import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

export default <template>
  <div class='field'>
    <@form.BasicRadioGroup
      @title='Statut CMV (cytomégalovirus)'
      @propertyName='cytomegalovirusStatus'
      @translationKey='pathology.cytomegalovirus-status'
      as |Group|
    >
      <div class='four unstackable fields'>
        <div class='field'>
          <Group.Radio @value='d_plus_r_plus' />
        </div>
        <div class='field'>
          <Group.Radio @value='d_plus_r_minus' />
        </div>
        <div class='field'>
          <Group.Radio @value='d_minus_r_minus' />
        </div>
        <div class='field'>
          <Group.Radio @value='d_minus_r_plus' />
        </div>
      </div>
    </@form.BasicRadioGroup>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
